import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';
import {
  Header,
  NoFavoritesRecent,
  FavoriteRecentList,
  ManageFavoriteRecent,
} from '../../components';

class Favorites extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  showHeader = () => {
    const { editListInprogress, t, list } = this.props;
    const favRecent = title => <Header title={title} />;
    let showFavRecent = null;
    if (editListInprogress) {
      showFavRecent = favRecent(t('favorites.label.manage-favorites'));
    } else {
      showFavRecent = favRecent(`${t('favorites.label.title')} (${list.length})`);
    }
    return showFavRecent;
  };

  showFavRecentList = () => {
    const { editListInprogress, list } = this.props;
    let showList = null;
    if (!editListInprogress && list.length > 0) {
      showList = <FavoriteRecentList />;
    } else if (editListInprogress && list.length > 0) {
      showList = <ManageFavoriteRecent />;
    }
    return showList;
  };

  render() {
    return (
      <React.Fragment>
        {this.showHeader()}
        <Divider />
        {this.showFavRecentList()}
        <NoFavoritesRecent />
      </React.Fragment>
    );
  }
}

Favorites.propTypes = {
  t: PropTypes.func.isRequired,
  list: PropTypes.array,
  editListInprogress: PropTypes.bool.isRequired,
};

Favorites.defaultProps = {
  list: [],
};

const mapStateToProps = ({ poi }) => ({
  list: poi.favorite_recent_list,
  editListInprogress: poi.edit_list_inprogress,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Favorites));
